import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { addyaragh, getAllYaragh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import { toggleNAluminiumUpvc } from "Constants/Constants";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from 'react-bootstrap-icons';

function NewBrandDialog({ reGetOnBack }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    yaraghName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 8,
        xs: 12
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
      col: {
        sm: 4,
        xs: 12
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  }

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  }

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { struct, yaraghName } = controls;
      try {
        const IdStruct = struct.value.value === "upvc" ? 1 : 2;
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdStruct: IdStruct,
          Name: yaraghName.value,
        };
        await dispatch(addyaragh(data));
        handleDialog();
        await reGetOnBack(true)
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
    setLoading(false);
  };

  const onEnter = () => {
    setCheckValid(false);
    setFormValid({});
    setControls({ yaraghName: { value: "" } });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiIconButton
        title= {<Translator id="addNewBrandFitting" />}
        icon={<Icons.FileEarmarkPlus size={17}/>}
        className="fix-size"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p> {<Translator id="addNewBrandFitting" />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2} className="d-flex align-items-end">
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}
                  >
                    {
                      controls[key].type === "text" &&
                      <Input
                        loading={loading}
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        checkValid={checkValid}
                        value={controls[key].value}
                      />
                    }
                    {
                      controls[key].type === "toggle" &&
                      <MuiRadioGroup
                        name={key}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio"
                      />
                    }
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default NewBrandDialog;
